/**
 * Keeps the selected color label in sync with the Linkify/Webyze swatches.
 * Guard against duplicate observers/listeners because product-info swaps
 * re-render parts of the product form on every non-color variant change.
 */
(function() {
  'use strict';

  const initializedContainers = new WeakSet();
  let updateTimer = null;

  function scheduleUpdate(delay) {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(updateSelectedColor, delay || 0);
  }

  function getOrCreateColorLabel(container) {
    let colorLabelContainer = container.previousElementSibling;

    if (!colorLabelContainer || !colorLabelContainer.classList.contains('pi-selected-color')) {
      const parent = container.parentElement;

      if (parent) {
        const siblings = Array.from(parent.children);
        const containerIndex = siblings.indexOf(container);

        for (let i = containerIndex - 1; i >= 0; i--) {
          if (siblings[i].classList.contains('pi-selected-color')) {
            colorLabelContainer = siblings[i];
            break;
          }
        }
      }
    }

    if (!colorLabelContainer || !colorLabelContainer.classList.contains('pi-selected-color')) {
      const existingContainer = document.querySelector('.pi-selected-color');
      if (existingContainer && container.parentElement && existingContainer.parentElement === container.parentElement) {
        colorLabelContainer = existingContainer;
      }
    }

    if (!colorLabelContainer || !colorLabelContainer.classList.contains('pi-selected-color')) {
      colorLabelContainer = document.createElement('div');
      colorLabelContainer.className = 'pi-selected-color';
      container.parentNode.insertBefore(colorLabelContainer, container);
    }

    return colorLabelContainer;
  }

  function updateSelectedColor() {
    const webyzeContainers = document.querySelectorAll('.webyzeProductColors');

    webyzeContainers.forEach(function(container) {
      const currentSwatch = container.querySelector('.swatchProductColor.currentSwatch');
      if (!currentSwatch) return;

      const ariaLabel = currentSwatch.getAttribute('aria-label');
      if (!ariaLabel) return;

      const colorLabelContainer = getOrCreateColorLabel(container);
      colorLabelContainer.textContent = ariaLabel;
    });
  }

  function initContainer(container) {
    if (!container || initializedContainers.has(container)) return;

    initializedContainers.add(container);

    const observer = new MutationObserver(function(mutations) {
      for (const mutation of mutations) {
        if (
          mutation.type === 'childList' ||
          (mutation.type === 'attributes' && mutation.attributeName === 'class')
        ) {
          scheduleUpdate(0);
          break;
        }
      }
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    container.addEventListener('click', function(e) {
      if (e.target.closest('.swatchProductColor')) {
        scheduleUpdate(100);
      }
    });
  }

  function initAllContainers() {
    document.querySelectorAll('.webyzeProductColors').forEach(initContainer);
    scheduleUpdate(0);
  }

  function boot() {
    window.setTimeout(initAllContainers, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('product-info:loaded', function() {
    window.setTimeout(initAllContainers, 300);
  });
})();
